/* @ngInject */
const sterileButtons = (
  icons,
  sterileAsk
) => {
  const self = {}

  self.delete = {
    icon: icons.delete,
    action: sterileAsk.delete,
    display: (_nature) => _nature === 'action',
    class: (_area) => 'retour',
  }

  return self
}
export default sterileButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/resources/buttons.resource.js